/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserIdTeamsQueryResponse,
  GetUserIdTeamsPathParams,
  GetUserIdTeams500,
} from "../types/GetUserIdTeams.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserIdTeamsQueryKey = (
  id: GetUserIdTeamsPathParams["id"] | undefined,
) => [{ url: "/user/:id/teams", params: { id: id } }] as const;

export type GetUserIdTeamsQueryKey = ReturnType<typeof getUserIdTeamsQueryKey>;

/**
 * @summary Получение команд пользователя
 * {@link /user/:id/teams}
 */
export async function getUserIdTeams(
  id: GetUserIdTeamsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserIdTeamsQueryResponse,
    ResponseErrorConfig<GetUserIdTeams500>,
    unknown
  >({ method: "GET", url: `/user/${id}/teams`, ...requestConfig });
  return res;
}

export function getUserIdTeamsQueryOptions(
  id: GetUserIdTeamsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserIdTeamsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetUserIdTeamsQueryResponse>,
    ResponseErrorConfig<GetUserIdTeams500>,
    ResponseConfig<GetUserIdTeamsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserIdTeams(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение команд пользователя
 * {@link /user/:id/teams}
 */
export function useGetUserIdTeams<
  TData = ResponseConfig<GetUserIdTeamsQueryResponse>,
  TQueryData = ResponseConfig<GetUserIdTeamsQueryResponse>,
  TQueryKey extends QueryKey = GetUserIdTeamsQueryKey,
>(
  id: GetUserIdTeamsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserIdTeamsQueryResponse>,
        ResponseErrorConfig<GetUserIdTeams500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getUserIdTeamsQueryKey(id);

  const query = useQuery(
    {
      ...getUserIdTeamsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserIdTeams500>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
